import React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import Grid from 'styled-components-grid';

import { withCssUnit } from '../utils/index';

const calculatePadding = (theme, gutterWidth, multiply = 1) => {
  const gw = !_.isNil(gutterWidth) ? gutterWidth : _.get(theme, 'gutterWidth');
  if (gw) {
    return withCssUnit(Math.floor(gw * multiply / 2));
  }
  return 0;
};

const StyledColumn = styled(
  ({
    children,
    flex,
    customStyle,
    gutterWidth,
    paddingUseBottom,
    paddingUseTop,
    ...rest
  }) => {
    return <Grid.Unit {...rest}>{children}</Grid.Unit>;
  }
)`
  ${({ flex }) => (flex ? 'display: flex;' : '')};
  padding-right: ${({ theme, gutterWidth }) => calculatePadding(theme, gutterWidth)};
  padding-left: ${({ theme, gutterWidth }) => calculatePadding(theme, gutterWidth)};
  ${({ theme, gutterWidth, paddingUseBottom }) => paddingUseBottom ? `padding-bottom: ${calculatePadding(theme, gutterWidth, 2)};` : ''}
  ${({ theme, gutterWidth, paddingUseTop }) => paddingUseTop ? `padding-top: ${calculatePadding(theme, gutterWidth, 2)};` : ''}
  ${({ customStyle }) => css`
    ${customStyle}
  `}
`;

const Column = ({
  className,
  size,
  children,
  gutterWidth,
  customStyle,
  paddingUseBottom = false,
  paddingUseTop = false,
  flex = false,
  ...rest
}) => {
  const sizeTranforms = {};
  _.each(size, (value, key) => {
    sizeTranforms[key] = parseInt(value, 10) / 12;
  });
  return (
    <StyledColumn
      className={className}
      size={sizeTranforms}
      gutterWidth={gutterWidth}
      customStyle={customStyle}
      paddingUseBottom={paddingUseBottom}
      paddingUseTop={paddingUseTop}
      flex={flex}
      {...rest}
    >
      {children}
    </StyledColumn>
  );
};

export default Column;
